import classnames from 'classnames';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { AVA_DOMAIN, AVA_URL } from '../../../constants';
import RoundedButton from '../../Buttons/RoundedButton';
import SearchAvaRoomInput from '../../Inputs/SearchAvaRoomInput';
import { getSnack } from '../../../utils/snackbar';
import useStyles from './InviteCard.styles';
const InviteCard = ({ addNotification, electronCaptionMode, setInviteCardOpen, status }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { closeSnackbar, enqueueSnackbar } = useSnackbar();
    const [currentTabIndex, setCurrentTabIndex] = useState(0);
    return (React.createElement(ClickAwayListener, { onClickAway: () => setInviteCardOpen(false) },
        React.createElement("div", { className: classes.root },
            React.createElement("header", { className: classes.header },
                React.createElement("button", { className: classnames(classes.tab, {
                        [classes.activeTab]: currentTabIndex === 0,
                    }), onClick: () => setCurrentTabIndex(0), disabled: currentTabIndex === 0 }, t('ccMode.inviteCard.inviteFriends')),
                React.createElement("button", { className: classnames(classes.tab, {
                        [classes.activeTab]: currentTabIndex === 1,
                    }), onClick: () => setCurrentTabIndex(1), disabled: currentTabIndex === 1 }, t('ccMode.inviteCard.joinARoom'))),
            React.createElement("section", { className: classes.panel },
                currentTabIndex === 0 && (React.createElement("div", { className: classes.inviteFriendsPanel },
                    React.createElement("div", { className: classes.linkContainer },
                        React.createElement("span", { className: classes.avaLink },
                            AVA_DOMAIN,
                            "/",
                            React.createElement("span", { className: classes.avaName },
                                "&",
                                status.host.avaName))),
                    React.createElement(RoundedButton, { className: classes.copyLink, color: "blue", onClick: () => {
                            const url = `${AVA_URL}/&${status.host.avaName}`;
                            if (window.navigator.share) {
                                window.navigator.share({ url });
                            }
                            else {
                                navigator.clipboard.writeText(url);
                                if (electronCaptionMode) {
                                    addNotification({
                                        text: t('addParticipant.theConversationLinkHasBeenCopiedToYourClipboard'),
                                        timestamp: Date.now(),
                                        type: 'default',
                                    });
                                }
                                else {
                                    getSnack({ enqueueSnackbar, closeSnackbar })(t('addParticipant.theConversationLinkHasBeenCopiedToYourClipboard'));
                                }
                            }
                            setInviteCardOpen(false);
                        } }, t('ccMode.inviteCard.copyLink')))),
                currentTabIndex === 1 && (React.createElement("div", { className: classes.joinRoomPanel },
                    React.createElement(SearchAvaRoomInput, null)))))));
};
export default InviteCard;
